import BOLTAnswerFooter from './BOLTAnswers';
import ConfidenceFooter from './Confidence';

type FooterProps = {
  isConfidenceVisible?: boolean;
  isBOLTAnswerVisible?: boolean;
  detailedAnswer?: string;
  confidenceLevel?: number;
  answer?: string;
  showFooter?: boolean;
  setShowFooter?: (...args: any[]) => any;
  handleConfidenceLevelColor?: (...args: any[]) => any;
  showGaugeIcon?: boolean;
};

const Footer = ({
  isConfidenceVisible = false,
  isBOLTAnswerVisible = false,
  detailedAnswer = '',
  confidenceLevel = null,
  answer = '',
  handleConfidenceLevelColor = () => {},
}: Readonly<FooterProps>) => {
  return (
    <footer
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        margin: 0,
      }}
    >
      {isConfidenceVisible && (
        <ConfidenceFooter
          confidenceLevel={confidenceLevel}
          detailedAnswer={detailedAnswer}
          handleConfidenceLevelColor={handleConfidenceLevelColor}
        />
      )}

      {isBOLTAnswerVisible && (
        <BOLTAnswerFooter
          confidenceLevel={confidenceLevel}
          detailedAnswer={detailedAnswer}
          answer={answer}
          handleConfidenceLevelColor={handleConfidenceLevelColor}
        />
      )}
    </footer>
  );
};

export default Footer;
